import ContractStore from '../stores/ContractStore'
import Web3Store from '../stores/Web3Store'

export async function getRegistered(eventId) {
    let oracleStatus;
    oracleStatus = await ContractStore.call("Oracles", "getRegistered", [Web3Store.account, eventId], {
        from: Web3Store.account
    });
    console.log("oracle status for event " + eventId + " is " + oracleStatus);
    return oracleStatus;
}



// WEBPACK FOOTER //
// ./src/contract/Oracles.js